/**********************************************************
Chemical Form

**********************************************************/
import { Select, DatePicker, SelectField, CheckBox } from '../inputs';
import { LOCATIONS, REPORT_TYPES } from '../../cult_constants';
import { packageForm } from '../../cult_utils';
import React from 'react';

const ReportForm = ({ fields, fetchFields, fetchCultivationReport, user }) => {
  return (
    <form id={'reports-form'} onSubmit={(e) => e.preventDefault()}>
      <div className="row">
        <div className="col s12 m12 l12 xl6">
          <DatePicker id={'reports-dateFrom'} label={'Date From'} min={'2018-01-01'} required={true} />
        </div>
        <div className="col s12 m12 l12 xl6">
          <DatePicker id={'reports-dateTo'} label={'Date To'} min={'2018-01-01'} required={true} />
        </div>
        <div className="col s12 m12 l12 xl6">
          <Select id={'reports-loc'} opts={LOCATIONS} label={'Location'} onChange={(e) => { fetchFields(e.target.value, e.target.id); }} />
        </div>
        <div className="col s12 m12 l12 xl6">
          <SelectField id={'reports-field'} opts={fields} label={'Field'} />
        </div>
      </div>
      <div className="row">
        <div className="col s12 m12 l12 xl12">
          <Select id={'reports-type'} opts={REPORT_TYPES} label={'Report Type'} required={true} />
        </div>
      </div>
      <div className="row">
        <div className="container">
          <div className="col s12 m6 l6 xl6">
            <CheckBox id={'reports-excel'} name={'reports-excel'} label={'Excel'} />
          </div>
          <div className="col s12 m6 l6 xl6">
            <CheckBox id={'reports-pdf'} name={'reports-pdf'} label={'PDF'} disabled={"disabled"} />
          </div>
        </div>
      </div><br />
      <div className="row">
        <div className="col s12 m12 l12 xl12">
          <center><button onClick={() => fetchCultivationReport({ opts: packageForm('reports-form'), user })} className="btn btn-large waves-effect">Fetch Report</button></center>
        </div>
      </div>
      <br />
    </form>
  );
};

export default ReportForm;



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/reports/report_form.js